import { useMemo } from 'react';
import { SarFieldInfoDefinition, SarFieldInfoDictionary, sarFieldInfoDictionary, SarFieldInfoSection } from './config/SarFieldInfoConfiguration';
import type {
  SarFieldInfoConfigurationParams,
  SarFieldInfoAdditionalPayloadSection,
  SarFieldInfoAdditionalPayload,
} from './SarInterfaces';
import SarParser from './SarParser';


const createFallbackDefinition = (fieldLabel: string, fieldType: string): SarFieldInfoDefinition => {
  const fallbackSections: SarFieldInfoSection[] = [
    {
      id: 'definition',
      title: 'Tanım',
      description: `${fieldLabel} alanı için detaylı tanım henüz eklenmedi.`,
      icon: 'info',
    },
    {
      id: 'mandatoryType',
      title: 'Zorunluluk Tipi',
      description: `${fieldLabel} alanı ${fieldType.toLowerCase()} olarak tanımlanmıştır.`,
      icon: 'info',
    },
    {
      id: 'other',
      title: 'Diğer Bilgiler',
      description: 'Ek bilgi bulunmuyor.',
      icon: 'info',
    },
  ];

  return {
    title: fieldLabel,
    sections: fallbackSections,
  };
};

export const resolveDefinition = (
  dictionary: SarFieldInfoDictionary,
  fieldPath: string,
  fieldLabel: string,
  fieldType: string,
  additionalInfo?: string,
): SarFieldInfoDefinition => {
  const directEntry = dictionary[fieldPath];
  if (directEntry) {
    return directEntry;
  }

  const lastSegment = fieldPath.split('.').pop();
  if (lastSegment && dictionary[lastSegment]) {
    return dictionary[lastSegment];
  }

  const parsedAdditional = SarParser.parseAdditionalInfo(additionalInfo);
  if (parsedAdditional) {
    return parsedAdditional;
  }

  return createFallbackDefinition(fieldLabel, fieldType);
};

export const useSarFieldInfoConfiguration = ({ fieldPath, fieldLabel, fieldType, additionalInfo }: SarFieldInfoConfigurationParams): SarFieldInfoDefinition => {
  return useMemo(
    () => resolveDefinition(sarFieldInfoDictionary, fieldPath, fieldLabel, fieldType, additionalInfo),
    [additionalInfo, fieldLabel, fieldPath, fieldType],
  );
};
